import React, { useContext, useEffect, useRef, useState } from "react";
import { useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import {
  makeStyles,
  Paper,
  InputBase,
  Tabs,
  Tab,
  Badge,
  IconButton,
  Typography,
  Grid,
  Tooltip,
  Switch,
} from "@material-ui/core";
import { Stack, alpha, Box } from "@mui/material";
import {
  Group,
  MoveToInbox as MoveToInboxIcon,
  CheckBox as CheckBoxIcon,
  MessageSharp as MessageSharpIcon,
  AccessTime as ClockIcon,
  Search as SearchIcon,
  Add as AddIcon,
  TextRotateUp,
  TextRotationDown,
} from "@material-ui/icons";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import ToggleButton from "@material-ui/lab/ToggleButton";

import { FilterAltOff, FilterAlt, PlaylistAddCheckOutlined } from "@mui/icons-material";

import NewTicketModal from "../NewTicketModal";
import TicketsList from "../TicketsListCustom";
import TabPanel from "../TabPanel";
import { Can } from "../Can";
import TicketsQueueSelect from "../TicketsQueueSelect";
import { TagsFilter } from "../TagsFilter";
import { UsersFilter } from "../UsersFilter";
import { StatusFilter } from "../StatusFilter";
import { WhatsappsFilter } from "../WhatsappsFilter";
import { Button, Snackbar } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { QueueSelectedContext } from "../../context/QueuesSelected/QueuesSelectedContext";

import api from "../../services/api";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

const useStyles = makeStyles((theme) => ({
  ticketsWrapper: {
    position: "relative",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflow: "hidden",
    // borderTopRightRadius: 0,
    // borderBottomRightRadius: 0,
  },

  tabsHeader: {
    minWidth: "auto",
    width: "auto",
    borderRadius: 8,
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    // backgroundColor: "#eee",
    // backgroundColor: theme.palette.tabHeaderBackground,
  },

  settingsIcon: {
    alignSelf: "center",
    marginLeft: "auto",
    padding: theme.spacing(1),
  },

  tab: {
    minWidth: "auto",
    width: "auto",
    padding: theme.spacing(0.5, 1),
    borderRadius: 8,
    transition: "0.3s",
    borderColor: "#aaa",
    borderWidth: "1px",
    borderStyle: "solid",
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),

    [theme.breakpoints.down("lg")]: {
      fontSize: "0.9rem",
      padding: theme.spacing(0.4, 0.8),
      marginRight: theme.spacing(0.4),
      marginLeft: theme.spacing(0.4),
    },

    [theme.breakpoints.down("md")]: {
      fontSize: "0.8rem",
      padding: theme.spacing(0.3, 0.6),
      marginRight: theme.spacing(0.3),
      marginLeft: theme.spacing(0.3),
    },

    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.1)",
    },

    // "&$selected": {
    //   color: "#FFF",
    //   backgroundColor: theme.palette.primary.main,
    // },
  },

  tabPanelItem: {
    minWidth: "33%",
    fontSize: 11,
    marginLeft: 0,
  },

  tabIndicator: {
    height: 6,
    bottom: 0,
    borderRadius: "0 0 8px 8px",
    backgroundColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
  },
  tabsBadge: {
    top: "105%",
    right: "55%",
    transform: "translate(45%, 0)",
    whiteSpace: "nowrap",
    borderRadius: "12px",
    padding: "0 8px",
    backgroundColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    color: theme.mode === "light" ? "#FFF" : theme.palette.primary.main,
  },
  ticketOptionsBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // background: "#fafafa",
    background: theme.palette.optionsBackground,
    borderRadius: 8,
    borderColor: "#aaa",
    borderWidth: "1px",
    borderStyle: "solid",
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    padding: theme.spacing(0.5),
  },

  serachInputWrapper: {
    flex: 1,
    height: 48,
    background: theme.palette.background.paper,
    display: "flex",
    borderRadius: 50,
    padding: "4px 16px",
    border: `1px solid ${theme.palette.divider}`,
    margin: theme.spacing(1),
    transition: "border .3s",
    "&:focus-within": {
      borderColor: theme.palette.primary.main,
      boxShadow: `0 0 0 2px ${theme.mode === "light" ? "rgba(0,124,102,0.1)" : "rgba(255,255,255,0.1)"}`
    }
  },

  searchIcon: {
    color: "grey",
    marginLeft: 6,
    marginRight: 6,
    alignSelf: "center",
  },

  searchInput: {
    flex: 1,
    border: "none",
    borderRadius: 30,
  },

  badge: {
    // right: "-10px",
  },

  customBadge: {
    right: "-10px",
    backgroundColor: "#f44336",
    color: "#fff",
  },

  show: {
    display: "block",
  },

  hide: {
    display: "none !important",
  },

  closeAllFab: {
    backgroundColor: "red",
    marginBottom: "4px",
    "&:hover": {
      backgroundColor: "darkred",
    },
  },

  speedDial: {
    position: "absolute",
    bottom: theme.spacing(1),
    right: theme.spacing(1),
    "& .MuiFab-root": {
      width: "40px",
      height: "40px",
      marginTop: "4px",
    },
    "& .MuiFab-label": {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },

  snackbar: {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: theme.palette.primary.main,
    color: "white",
    borderRadius: 30,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8em",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1em",
    },
  },

  yesButton: {
    backgroundColor: "#FFF",
    color: "rgba(0, 100, 0, 1)",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "darkGreen",
      color: "#FFF",
    },
    borderRadius: 30,
  },
  noButton: {
    backgroundColor: "#FFF",
    color: "rgba(139, 0, 0, 1)",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    "&:hover": {
      backgroundColor: "darkRed",
      color: "#FFF",
    },
    borderRadius: 30,
  },
  filterIcon: {
    marginRight: 6,
    alignSelf: "center",
    color: theme.mode === "light" ? "#0872b9" : "#FFF",
    cursor: "pointer",
  },
  button: {
    height: 30,
    width: 30,
    border: "2px solid",
    borderColor: "#aaa",
    borderRadius: 8,
    marginRight: 8,
    "&:hover": {
      borderColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  icon: {
    color: "#aaa",
    "&:hover": {
      color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  buttonOpen: {
    "& $icon": {
      color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  modernButton: {
    borderRadius: 50,
  }
}));

const TicketsManagerTabs = () => {
  const theme = useTheme();
  const classes = useStyles();
  const history = useHistory();

  const [searchParam, setSearchParam] = useState("");
  const [tab, setTab] = useState("open");
  // const [tabOpen, setTabOpen] = useState("open");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [showAllTickets, setShowAllTickets] = useState(false);
  const [sortTickets, setSortTickets] = useState(false);

  const searchInputRef = useRef();
  const [searchOnMessages, setSearchOnMessages] = useState(false);

  const { user } = useContext(AuthContext);
  const { profile } = user;
  const { setSelectedQueuesMessage } = useContext(QueueSelectedContext);
  const { tabOpen, setTabOpen } = useContext(TicketsContext);

  const [openCount, setOpenCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [groupingCount, setGroupingCount] = useState(0);

  const userQueueIds = user.queues.map((q) => q.id);
  const [selectedQueueIds, setSelectedQueueIds] = useState(userQueueIds || []);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedWhatsapp, setSelectedWhatsapp] = useState([]);
  const [forceSearch, setForceSearch] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [filter, setFilter] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [hoveredButton, setHoveredButton] = useState(null);
  const [isHoveredAll, setIsHoveredAll] = useState(false);
  const [isHoveredNew, setIsHoveredNew] = useState(false);
  const [isHoveredResolve, setIsHoveredResolve] = useState(false);
  const [isHoveredOpen, setIsHoveredOpen] = useState(false);
  const [isHoveredClosed, setIsHoveredClosed] = useState(false);
  const [isHoveredSort, setIsHoveredSort] = useState(false);

  const [isFilterActive, setIsFilterActive] = useState(false);

  useEffect(() => {
    setSelectedQueuesMessage(selectedQueueIds);
  }, [selectedQueueIds]);

  useEffect(() => {
    if (user.profile.toUpperCase() === "ADMIN" || user.allUserChat.toUpperCase() === "ENABLED") {
      setShowAllTickets(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (tab === "search") {
      searchInputRef.current.focus();
    }
    setForceSearch(!forceSearch);
  }, [tab]);

  let searchTimeout;

  const handleSearch = (e) => {
    const searchedTerm = e.target.value.toLowerCase();

    clearTimeout(searchTimeout);

    if (searchedTerm === "") {
      setSearchParam(searchedTerm);
      setForceSearch(!forceSearch);
      setFilter(false);
      setIsFilterActive(false);
      setTab("open");
      return;
    } else if (tab !== "search") {
      setFilter(true);
      setIsFilterActive(true);
      setTab("search");
    }

    searchTimeout = setTimeout(() => {
      setSearchParam(searchedTerm);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleBack = () => {

    history.push("/tickets");
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  const handleChangeTabOpen = (e, newValue) => {
    // if (newValue === "pending" || newValue === "group") {
    handleBack();
    // }

    setTabOpen(newValue);
  };

  const applyPanelStyle = (status) => {
    if (tabOpen !== status) {
      return { width: 0, height: 0 };
    }
  };

  const handleSnackbarOpen = () => {
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const CloseAllTicket = async () => {
    try {
      const { data } = await api.post("/tickets/closeAll", {
        status: tabOpen,
        selectedQueueIds,
      });
      handleSnackbarClose();
    } catch (err) {
      console.log("Error: ", err);
    }
  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      history.push(`/tickets/${ticket.uuid}`);
    }
  };

  const handleSelectedTags = (selecteds) => {
    const tags = selecteds.map((t) => t.id);

    clearTimeout(searchTimeout);

    if (tags.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }

    searchTimeout = setTimeout(() => {
      setSelectedTags(tags);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleSelectedUsers = (selecteds) => {
    const users = selecteds.map((t) => t.id);

    clearTimeout(searchTimeout);

    if (users.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }
    searchTimeout = setTimeout(() => {
      setSelectedUsers(users);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleSelectedWhatsapps = (selecteds) => {
    const whatsapp = selecteds.map((t) => t.id);

    clearTimeout(searchTimeout);

    if (whatsapp.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }
    searchTimeout = setTimeout(() => {
      setSelectedWhatsapp(whatsapp);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleSelectedStatus = (selecteds) => {
    const statusFilter = selecteds.map((t) => t.status);

    clearTimeout(searchTimeout);

    if (statusFilter.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }

    searchTimeout = setTimeout(() => {
      setSelectedStatus(statusFilter);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleFilter = () => {
    if (filter) {
      setFilter(false);
      setIsFilterActive(false);
      setTab("open");
    } else {
      setFilter(true);
      setIsFilterActive(true);
      setTab("search");
    }
  };

  const [open, setOpen] = React.useState(false);
  const [hidden, setHidden] = React.useState(false);

  const handleVisibility = () => {
    setHidden((prevHidden) => !prevHidden);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClosed = () => {
    setOpen(false);
  };

  const tooltipTitleStyle = {
    fontSize: "10px",
  };

  return (
    <Paper
      elevation={0}
      className={classes.ticketsWrapper}
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        background: "transparent",
        border: "none",
        borderRadius: 0
      }}
    >
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />

      {/* Messenger-like Header */}
      <Box sx={{ p: 2, pb: 0, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h5" color="primary" style={{ fontWeight: 700, ml: 8 }}>
          Conversas
        </Typography>
        <Stack direction="row" spacing={1}>
          <Tooltip title="Novo Ticket">
            <IconButton
              size="small"
              onClick={() => {
                setNewTicketModalOpen(true);
              }}
              sx={{
                bgcolor: 'transparent',
                color: 'text.secondary'
              }}
            >
              <AddIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Filtros e Opções">
            <IconButton
              size="small"
              onClick={handleFilter}
              sx={{
                bgcolor: isFilterActive ? alpha(theme.palette.primary.main, 0.1) : 'transparent',
                color: isFilterActive ? 'primary.main' : 'text.secondary'
              }}
            >
              {isFilterActive ? <FilterAlt /> : <FilterAltOff />}
            </IconButton>
          </Tooltip>
        </Stack>
      </Box>

      {/* Modern Search Bar */}
      <div className={classes.serachInputWrapper} style={{
        background: theme.mode === "light" ? "#f0f2f5" : "#3c3c3c",
        border: "none",
        borderRadius: 20, // Pill shape
        padding: "0px 12px",
        height: 40, // Slightly smaller height
        margin: "12px 16px"
      }}>
        <SearchIcon className={classes.searchIcon} style={{ color: theme.mode === "light" ? "#65676b" : "#b0b3b8" }} />
        <InputBase
          className={classes.searchInput}
          inputRef={searchInputRef}
          placeholder={i18n.t("tickets.search.placeholder")}
          type="search"
          onChange={handleSearch}
          style={{ fontSize: '0.95rem' }}
        />
      </div>

      {filter === true && (
        <>
          <TagsFilter onFiltered={handleSelectedTags} />
          <WhatsappsFilter onFiltered={handleSelectedWhatsapps} />
          <StatusFilter onFiltered={handleSelectedStatus} />
          {profile === "admin" && (
            <>
              <UsersFilter onFiltered={handleSelectedUsers} />
            </>
          )}

          {/* Options Bar - Moved inside filter block */}
          <Paper square elevation={0} className={classes.ticketOptionsBox}>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid item>
                <Can
                  role={user.allUserChat === 'enabled' && user.profile === 'user' ? 'admin' : user.profile}
                  perform="tickets-manager:showall"
                  yes={() => (
                    <Badge
                      color="primary"
                      invisible={
                        !isHoveredAll ||
                        isHoveredNew ||
                        isHoveredResolve ||
                        isHoveredOpen ||
                        isHoveredClosed
                      }
                      badgeContent={"Todos"}
                      classes={{ badge: classes.tabsBadge }}
                    >
                      <ToggleButton
                        onMouseEnter={() => setIsHoveredAll(true)}
                        onMouseLeave={() => setIsHoveredAll(false)}
                        className={classes.button}
                        value="uncheck"
                        selected={showAllTickets}
                        onChange={() =>
                          setShowAllTickets((prevState) => !prevState)
                        }
                      >
                        {showAllTickets ? (
                          <VisibilityIcon className={classes.icon} />
                        ) : (
                          <VisibilityOffIcon className={classes.icon} />
                        )}
                      </ToggleButton>
                    </Badge>
                  )}
                />
                <Snackbar
                  open={snackbarOpen}
                  onClose={handleSnackbarClose}
                  message={i18n.t("tickets.inbox.closedAllTickets")}
                  ContentProps={{
                    className: classes.snackbar,
                  }}
                  action={
                    <>
                      <Button
                        className={classes.yesButton}
                        size="small"
                        onClick={CloseAllTicket}
                      >
                        {i18n.t("tickets.inbox.yes")}
                      </Button>
                      <Button
                        className={classes.noButton}
                        size="small"
                        onClick={handleSnackbarClose}
                      >
                        {i18n.t("tickets.inbox.no")}
                      </Button>
                    </>
                  }
                />
                {/* Note: NewTicket Button logic is duplicated in header, keeping here for completeness if user wants it in bar too, 
                    but strictly following 'hide bar' request. */}
                <Badge
                  color="primary"
                  invisible={
                    isHoveredAll ||
                    !isHoveredNew ||
                    isHoveredResolve ||
                    isHoveredOpen ||
                    isHoveredClosed
                  }
                  badgeContent={i18n.t("tickets.inbox.newTicket")}
                  classes={{ badge: classes.tabsBadge }}
                >
                  <IconButton
                    onMouseEnter={() => setIsHoveredNew(true)}
                    onMouseLeave={() => setIsHoveredNew(false)}
                    className={classes.button}
                    onClick={() => {
                      setNewTicketModalOpen(true);
                    }}
                  >
                    <AddIcon className={classes.icon} />
                  </IconButton>
                </Badge>
                {user.profile === "admin" && (
                  <Badge
                    color="primary"
                    invisible={
                      isHoveredAll ||
                      isHoveredNew ||
                      !isHoveredResolve ||
                      isHoveredOpen ||
                      isHoveredClosed
                    }
                    badgeContent={i18n.t("tickets.inbox.closedAll")}
                    classes={{ badge: classes.tabsBadge }}
                  >
                    <IconButton
                      onMouseEnter={() => setIsHoveredResolve(true)}
                      onMouseLeave={() => setIsHoveredResolve(false)}
                      className={classes.button}
                      onClick={handleSnackbarOpen}
                    >
                      <PlaylistAddCheckOutlined style={{ color: theme.mode === "light" ? "green" : "#FFF" }} />
                    </IconButton>
                  </Badge>
                )}
                <Badge
                  // color="primary"
                  invisible={
                    !(
                      tab === "open" &&
                      !isHoveredAll &&
                      !isHoveredNew &&
                      !isHoveredResolve &&
                      !isHoveredClosed &&
                      !isHoveredSort
                    ) && !isHoveredOpen
                  }
                  badgeContent={i18n.t("tickets.inbox.open")}
                  classes={{ badge: classes.tabsBadge }}
                >
                  <IconButton
                    onMouseEnter={() => {
                      setIsHoveredOpen(true);
                      setHoveredButton("open");
                    }}
                    onMouseLeave={() => {
                      setIsHoveredOpen(false);
                      setHoveredButton(null);
                    }}
                    style={{
                      height: 30,
                      width: 30,
                      border: isHoveredOpen
                        ? theme.mode === "light"
                          ? "3px solid " + theme.palette.primary.main
                          : "3px solid #FFF"
                        : tab === "open"
                          ? theme.mode === "light"
                            ? "3px solid " + theme.palette.primary.main
                            : "3px solid #FFF"
                          : theme.mode === "light"
                            ? "2px solid #aaa"
                            : "2px solid #aaa",
                      borderRadius: 8,
                      marginRight: 8,
                    }}
                    onClick={() => handleChangeTab(null, "open")}
                  >
                    <MoveToInboxIcon
                      style={{
                        color: isHoveredOpen
                          ? theme.mode === "light"
                            ? theme.palette.primary.main
                            : "#FFF"
                          : tab === "open"
                            ? theme.mode === "light"
                              ? theme.palette.primary.main
                              : "#FFF"
                            : "#aaa",
                      }}
                    />
                  </IconButton>
                </Badge>

                <Badge
                  color="primary"
                  invisible={
                    !(
                      tab === "closed" &&
                      !isHoveredAll &&
                      !isHoveredNew &&
                      !isHoveredResolve &&
                      !isHoveredOpen &&
                      !isHoveredSort
                    ) && !isHoveredClosed
                  }
                  badgeContent={i18n.t("tickets.inbox.resolverd")}
                  classes={{ badge: classes.tabsBadge }}
                >
                  <IconButton
                    onMouseEnter={() => {
                      setIsHoveredClosed(true);
                      setHoveredButton("closed");
                    }}
                    onMouseLeave={() => {
                      setIsHoveredClosed(false);
                      setHoveredButton(null);
                    }}
                    style={{
                      height: 30,
                      width: 30,
                      border: isHoveredClosed
                        ? theme.mode === "light"
                          ? "3px solid " + theme.palette.primary.main
                          : "3px solid #FFF"
                        : tab === "closed"
                          ? theme.mode === "light"
                            ? theme.palette.primary.main
                            : "3px solid #FFF"
                          : theme.mode === "light"
                            ? "2px solid #aaa"
                            : "2px solid #aaa",
                      borderRadius: 8,
                      marginRight: 8,
                    }}
                    onClick={() => handleChangeTab(null, "closed")}
                  >
                    <CheckBoxIcon
                      style={{
                        color: isHoveredClosed
                          ? theme.mode === "light"
                            ? theme.palette.primary.main
                            : "#FFF"
                          : tab === "closed"
                            ? theme.mode === "light"
                              ? theme.palette.primary.main
                              : "#FFF"
                            : "#aaa",
                      }}
                    />
                  </IconButton>
                </Badge>
                {/* Sort Button */}
                {tab !== "closed" && tab !== "search" && (
                  <Badge
                    color="primary"
                    invisible={
                      !isHoveredSort ||
                      isHoveredAll ||
                      isHoveredNew ||
                      isHoveredResolve ||
                      isHoveredOpen ||
                      isHoveredClosed
                    }
                    badgeContent={!sortTickets ? "Crescente" : "Decrescente"}
                    classes={{ badge: classes.tabsBadge }}
                  >
                    <ToggleButton
                      onMouseEnter={() => setIsHoveredSort(true)}
                      onMouseLeave={() => setIsHoveredSort(false)}
                      className={classes.button}
                      value="uncheck"
                      selected={sortTickets}
                      onChange={() =>
                        setSortTickets((prevState) => !prevState)
                      }
                    >
                      {!sortTickets ? (
                        <TextRotateUp style={{
                          color: sortTickets
                            ? theme.mode === "light"
                              ? theme.palette.primary.main
                              : "#FFF"
                            : "#aaa",
                        }} />
                      ) : (
                        <TextRotationDown style={{
                          color: sortTickets
                            ? theme.mode === "light"
                              ? theme.palette.primary.main
                              : "#FFF"
                            : "#aaa",
                        }} />
                      )}
                    </ToggleButton>
                  </Badge>
                )}
              </Grid>

              <Grid item>
                <TicketsQueueSelect
                  selectedQueueIds={selectedQueueIds}
                  userQueues={user?.queues}
                  onChange={(values) => setSelectedQueueIds(values)}
                />
              </Grid>
            </Grid>
          </Paper>
        </>
      )}
      <TabPanel value={tab} name="open" className={classes.ticketsWrapper}>
        <Tabs
          value={tabOpen}
          onChange={handleChangeTabOpen}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="off"
          TabIndicatorProps={{ style: { display: 'none' } }}
          style={{ paddingLeft: 16, paddingRight: 16, marginBottom: 12, minHeight: 40 }}
        >
          {/* ATENDENDO */}
          <Tab
            label={i18n.t("ticketsList.assignedHeader") + ` (${openCount})`}
            value={"open"}
            name="open"
            style={{
              minWidth: 'auto',
              fontSize: 14,
              fontWeight: tabOpen === 'open' ? 600 : 400,
              borderRadius: 30,
              marginRight: 8,
              backgroundColor: tabOpen === 'open' ? alpha(theme.palette.primary.main, 0.12) : '#f0f2f5', // WhatsApp Web style: Active = Soft Primary, Inactive = Light Grey
              color: tabOpen === 'open' ? theme.palette.primary.main : '#54656f',
              border: 'none',
              textTransform: 'none',
              padding: '6px 12px',
              minHeight: 32,
              height: 32
            }}
          />

          {/* AGUARDANDO */}
          <Tab
            label={i18n.t("ticketsList.pendingHeader") + ` (${pendingCount})`}
            value={"pending"}
            name="pending"
            style={{
              minWidth: 'auto',
              fontSize: 14,
              fontWeight: tabOpen === 'pending' ? 600 : 400,
              borderRadius: 30,
              marginRight: 8,
              backgroundColor: tabOpen === 'pending' ? alpha(theme.palette.primary.main, 0.12) : '#f0f2f5',
              color: tabOpen === 'pending' ? theme.palette.primary.main : '#54656f',
              border: 'none',
              textTransform: 'none',
              padding: '6px 12px',
              minHeight: 32,
              height: 32
            }}
          />

          {/* GRUPOS */}
          {user.allowGroup && (
            <Tab
              label={i18n.t("ticketsList.groupingHeader") + ` (${groupingCount})`}
              value={"group"}
              name="group"
              style={{
                minWidth: 'auto',
                fontSize: 14,
                fontWeight: tabOpen === 'group' ? 600 : 400,
                borderRadius: 30,
                marginRight: 8,
                backgroundColor: tabOpen === 'group' ? alpha(theme.palette.primary.main, 0.12) : '#f0f2f5',
                color: tabOpen === 'group' ? theme.palette.primary.main : '#54656f',
                border: 'none',
                textTransform: 'none',
                padding: '6px 12px',
                minHeight: 32,
                height: 32
              }}
            />
          )}
        </Tabs>

        <Paper elevation={0} square style={{ display: 'flex', flexDirection: 'column', flex: 1, overflowY: 'hidden' }}>
          <TicketsList
            status="open"
            showAll={showAllTickets}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            selectedQueueIds={selectedQueueIds}
            updateCount={(val) => setOpenCount(val)}
            style={applyPanelStyle("open")}
            setTabOpen={setTabOpen}
          />
          <TicketsList
            status="pending"
            selectedQueueIds={selectedQueueIds}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            showAll={user.profile === "admin" || user.allUserChat === 'enabled' ? showAllTickets : false}
            updateCount={(val) => setPendingCount(val)}
            style={applyPanelStyle("pending")}
            setTabOpen={setTabOpen}
          />
          {user.allowGroup && (
            <TicketsList
              status="group"
              showAll={showAllTickets}
              sortTickets={sortTickets ? "ASC" : "DESC"}
              selectedQueueIds={selectedQueueIds}
              updateCount={(val) => setGroupingCount(val)}
              style={applyPanelStyle("group")}
              setTabOpen={setTabOpen}
            />
          )}
        </Paper>
      </TabPanel>
      <TabPanel value={tab} name="closed" className={classes.ticketsWrapper}>
        <TicketsList
          status="closed"
          showAll={showAllTickets}
          selectedQueueIds={selectedQueueIds}
          setTabOpen={setTabOpen}
        />
      </TabPanel>
      <TabPanel value={tab} name="search" className={classes.ticketsWrapper}>
        {profile === "admin" && (
          <>
            <TicketsList
              statusFilter={selectedStatus}
              searchParam={searchParam}
              showAll={showAllTickets}
              tags={selectedTags}
              users={selectedUsers}
              selectedQueueIds={selectedQueueIds}
              whatsappIds={selectedWhatsapp}
              forceSearch={forceSearch}
              searchOnMessages={searchOnMessages}
              status="search"
            />
          </>
        )}

        {profile === "user" && (
          <TicketsList
            statusFilter={selectedStatus}
            searchParam={searchParam}
            showAll={false}
            tags={selectedTags}
            selectedQueueIds={selectedQueueIds}
            whatsappIds={selectedWhatsapp}
            forceSearch={forceSearch}
            searchOnMessages={searchOnMessages}
            status="search"
          />
        )}
      </TabPanel>
    </Paper >
  );
};

export default TicketsManagerTabs;
